import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import theme from './theme';
import { ToastProvider } from './components/ToastProvider';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import TasksPage from './pages/TasksPage';
import TimeLogsPage from './pages/TimeLogsPage';
import CategoriesPage from './pages/CategoriesPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ChatPage from './pages/ChatPage';
import ProfilePage from './pages/ProfilePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60 * 1000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              {/* public: linked from the login page and the Google/Facebook consent screens */}
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route element={<AppLayout />}>
                <Route path="/tasks" element={<TasksPage />} />
                <Route path="/time-logs" element={<TimeLogsPage />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/assistant" element={<ChatPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                {/* legacy paths from the previous version of the app */}
                <Route path="/todos" element={<Navigate to="/tasks" replace />} />
                <Route path="/timelogger" element={<Navigate to="/time-logs" replace />} />
                <Route path="/" element={<Navigate to="/tasks" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
